import { createContext } from 'react';
import { MatrixClient } from 'matrix-js-sdk';

export type TMatrixConnectionStatus = 'connecting' | 'connected' | 'reconnecting' | 'disconnected' | 'unavailable';

export interface IMatrixContextValue {
    client: MatrixClient | null;
    connectionStatus: TMatrixConnectionStatus;
    disconnect: () => Promise<void>;
    reconnect: () => Promise<void>;
}

export const defaultMatrixContextValue: IMatrixContextValue = {
    client: null,
    connectionStatus: 'connecting',
    disconnect: async () => undefined,
    reconnect: async () => undefined
};

const MatrixContext = createContext<IMatrixContextValue>(defaultMatrixContextValue);

export default MatrixContext;
